import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Progress from './Progress'
import './style.scss'

class ProgressBar extends Component {
  getFirstAndLastValuableItemsIndexes = progressList =>
    progressList.reduce(
      ([firstIndex, lastIndex], item, index) => {
        if (item.value > 0) {
          if (firstIndex === null) {
            // eslint-disable-next-line no-param-reassign
            firstIndex = index
          }

          // eslint-disable-next-line no-param-reassign
          lastIndex = index
        }

        return [firstIndex, lastIndex]
      },
      [null, null],
    )

  render() {
    const { label, progressList } = this.props
    const [firstIndex, lastIndex] = this.getFirstAndLastValuableItemsIndexes(
      progressList,
    )
    let indent = 0

    return (
      <div className="pg-bar">
        {progressList.map((progress, index) => {
          if (index > 0) {
            const prevProgress = progressList[index - 1]
            indent += prevProgress.value
          }

          return (
            <Progress
              key={index}
              indent={indent}
              isFirst={firstIndex === index}
              isLast={lastIndex === index}
              progress={progress}
            />
          )
        })}
        <span className="pg-bar-label">{label}</span>
      </div>
    )
  }
}

ProgressBar.propTypes = {
  progressList: PropTypes.array,
}

ProgressBar.defaultProps = {
  progressList: [],
}

export default ProgressBar
